import {BaseContainerModel} from '../../base-container.model';
import {
    bl_fi_mst_entity_driver_link_RowClass,
    bl_fi_mst_entity_driver_link_RowInterface
} from '../../../dbschema/index';

export class EntityDriverLinkContainerModel extends BaseContainerModel {
    bl_fi_mst_entity_driver_link: bl_fi_mst_entity_driver_link_RowInterface = new bl_fi_mst_entity_driver_link_RowClass();
}
